<div class="row">
  <div class="col-12" *yatVar="paymentResponseHandled$ | async as handlingResponse">
    <ng-container *ngIf="pricingInformation === null || pricingInformation === 'LOADING' || handlingResponse; else buttons">
      <button yat-button type="button" class="flex flex-row-reverse btn btn-large primary w-100" [disabled]="true" [yatSpinner]="true">
        {{
          (handlingResponse
            ? debitDate === null
              ? 'checkout.paymentWallet.walletButton.handlingResponseWalletButton'
              : 'checkout.paymentWallet.walletButton.handlingResponseWalletButtonDelayedPayment'
            : 'checkout.paymentWallet.walletButton.loadingWalletButton'
          ) | transloco
        }}
      </button>
    </ng-container>
    <ng-template #buttons>
      <ng-container *ngIf="pricingInformation !== null && pricingInformation !== 'LOADING'">
        <yat-google-pay-button
          *ngIf="activeWallet === 'GOOGLE_PAY'"
          [buttonText]="walletButtonTextMode"
          [buttonLanguage]="(buttonLanguage$ | async) ?? 'en'"
          [debitDate]="debitDate"
          [pricingInformation]="pricingInformation"
          [walletButtonEnvironment]="walletButtonEnvironment"
          [vendorName]="vendorName"
          [businessModel]="businessModel"
          (loadPaymentData)="walletPaymentSuccessful.next({ type: 'GOOGLE_PAY', paymentData: $event })"></yat-google-pay-button>
        <yat-apple-pay-button
          *ngIf="activeWallet === 'APPLE_PAY'"
          [buttonType]="walletButtonTextMode"
          [buttonLanguage]="(buttonLanguage$ | async) ?? 'en'"
          [debitDate]="debitDate"
          [pricingInformation]="pricingInformation"
          [walletButtonEnvironment]="walletButtonEnvironment"
          [vendorName]="vendorName"
          [businessModel]="businessModel"
          (loadPaymentData)="walletPaymentSuccessful.next({ type: 'APPLE_PAY', paymentData: $event })"></yat-apple-pay-button>
      </ng-container>
    </ng-template>
  </div>
</div>
